import React from 'react';
import urls from '../configs/urls'
import { Redirect} from 'react-router'
import '../css/Shop.css';
import '../css/Services.css';
import ls from 'local-storage'
import axios from 'axios';
import Retry from "./Retry";
import ServiceCategory from "../Modules/ServiceCategory";
import AppBody from "./AppBody";
import SliderImage from "../Modules/SliderImage";

import CustomSlider from "./CustomSlider";
import MainMenuItem from "./MainMenuItem";
class Services extends React.Component{
    list =[];
    hasMoreProductToLoad = true;
    content = document.getElementsByClassName("content")[0];
    constructor(props){
        super(props);
        this.state = {
            redirect: false,
            cat_id: 0,
            retry: false,
            error: false,
            error_text: "",
            loading: true,
            categories: [],
            images:[],
            items:[],
        };

    }

    componentDidMount = () => {

        this.getServices();
    };

    render() {
        if(this.state.redirect)
            return (<Redirect push to={this.state.url}/>);
        if(this.state.retry)
            return (<Retry url={"/home"} type={"RELOAD"} text={"در اجرای درخواست مشکلی پیش آمده است. لطفا مجددا تلاش کنید."}/>);
        if(this.state.error)
            return (
                <div className="App-body bg-white">
                    <div className={"infoMessage"}>
                        {this.state.error_text}
                    </div>
                    <form onSubmit={this.handleSubmit}>
                        <input type={"submit"} className={"btn submitPhone"} value={"صفحه اصلی"}/>
                    </form>
                </div>
            );


        return (
            <AppBody loading={this.state.loading} name={"خدماتی"} type={" alice"} hasSlider={true}>
                <CustomSlider slides={this.state.images}/>
                {this.renderCats()}
                <div id={"MainMenuItems"}>
                    {this.renderItems()}
                </div>
            </AppBody>
        );
    }
    renderCats(){
        return this.state.categories.map((data)=>{
            return (
                <div className={"catShopElm"}  onClick={()=>this.onCategoryClick((data))}>
                    <div className={"catShopImgElm"}>
                        <img className={"catShopImg"} src={urls.SiteUrl+"upload/"+data.img}/>
                    </div>
                    <div className={"catShopText"}>{data.name}</div>
                </div>
            )
        });
    }
    renderItems(){
        return this.state.items.map((data)=>{
            return (
                <MainMenuItem item={data}/>
            )
        });
    }

    onCategoryClick(category){
        ls.set("category_service_id",category.id);
        this.props.history.push({
            pathname: '/categories_of_services',
            state: {category_service_id:category.id}
        });
    }

    getServices(){
        this.setState({loading:true});
        axios.get(urls.baseUrl+urls.getServices+"?"
            +"token="+ls.get("token")
            +"&city_id="+ls.get("city_id"))
            .then(res => {
                if(res.data.code == 200){
                    let cat = [];
                    res.data.categorykh.forEach((category)=>{
                        cat.push(new ServiceCategory(category));
                    });
                    console.log("MENU : ",res.data.admin_menu);
                    res.data.admin_menu.forEach((menu)=>{
                        cat.push(new ServiceCategory({id:menu.id,img:"menuapp/"+menu.img,cat_name:menu.title,isAdminMenu:1}));
                    });
                    let sliderImages = [];
                    res.data.sliders.forEach((image)=>{
                        sliderImages.push(new SliderImage(image));
                    });
                    this.setState({
                        images:sliderImages,
                        categories:cat,
                        cat_id:(cat.length>0 && cat[cat.length-1]!=null)?cat[cat.length-1].id:null,
                        items:res.data.items,
                        loading:false
                    });
                }
                else{
                    alert(res.data.message())
                }
            })
            .catch(error => {
                console.log(error);
                this.setState({retry:true,loading:false});
            });
    }
}



export default Services;
